<template>
  <div class="prompt">
    <div
      class="body-2-expanded prompt__text"
      v-text="$t('login.prompt.text')"
    />

    <login-modal
      ref="actionModalRef"
      :modal-id="$props.modalId"
    />

    <template v-if="$props.navigateToDvp">
      <basic-link
        class="prompt__link"
        data-track-as="login_start"
        :data-track-text="$props.channel"
        :label="$t('login.prompt.title')"
        :href="`${APP.DVP.env}/${selectedLanguage.toLowerCase()}/persons?open=login&source=${$props.channel}`"
      />
    </template>

    <template v-else>
      <basic-text-button
        class="prompt__link"
        data-track-as="login_start"
        :data-track-text="$props.channel"
        :label="$t('login.prompt.title')"
        @click="openLoginModal"
      >
        <template #trailing>
          <the-icon
            art="solid"
            name="arrow-right"
          />
        </template>
      </basic-text-button>
    </template>
  </div>
</template>

<script setup>
  import { ref } from 'vue'

  import events$ from '@shared/services/Events'

  import useI18n from '@shared/hooks/useI18n'

  import { BasicLink, BasicTextButton } from '@shared/components/Basic'
  import LoginModal from '@shared/components/Login/Modal'

  import { EVENT_LOGIN } from '@shared/config/events'
  import { APP } from '@shared/config/constants'

  // HOOKS
  const { selectedLanguage } = useI18n()

  // INIT
  const props = defineProps({
    callerId: {
      type: String,
      default: null,
    },

    channel: {
      type: String,
      required: true,
    },

    modalId: {
      type: String,
      required: true,
    },

    navigateToDvp: {
      type: Boolean,
      default: false,
    },
  })

  // DATA
  const actionModalRef = ref(null)

  // METHODS
  function openLoginModal() {
    const payload = {
      callerId: props.callerId,
      channel: props.channel,
      modalId: props.modalId,
      navigateToDvp: props.navigateToDvp,
    }

    events$.emit(EVENT_LOGIN.OPEN, payload)
  }

  defineExpose({ actionModalRef, openLoginModal })
</script>

<style scoped>
.prompt {
  display: flex;
  flex-direction: column;
}

@media (--v-medium) {
  .prompt {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: var(--fixed-spacing-fix-04);
    align-items: center;
  }
}
</style>
